export interface ProfileStudioEntry {
  screen: 'avatar' | 'circle' | 'photo';
  avatarId?: number;
}
const key = 'steos:studio:profile-entry';
/** Переход хранит только выбранный ресурс. Сам профиль и выбор «Вы» не изменяются. */
export function openProfileStudio(entry: ProfileStudioEntry) {
  sessionStorage.removeItem('steos:history:repeat');
  sessionStorage.setItem(key, JSON.stringify(entry));
  location.hash = '#studio';
}
export function profileStudioEntry(): ProfileStudioEntry | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(key) || 'null') as ProfileStudioEntry | null;
    return value &&
      ['avatar', 'circle', 'photo'].includes(value.screen) &&
      (value.avatarId === undefined || (Number.isSafeInteger(value.avatarId) && value.avatarId > 0))
      ? value
      : null;
  } catch {
    return null;
  }
}
